<script setup>
useHead({
  title: "Best Software Development Company for All The Industries",
  meta: [
    {
      name: "description",
      content:
        "WebReinvent is Best Software Development Company in Delhi India. We are leader in providing software services in Health Care and Fitness, Education and Training, Retail and eCommerce, Sports and Entertainment, Media and Publishing, Food and Beverage industries in Delhi.",
    },
    {
      name: "keywords",
      content:
        "Health Care and Fitness, Education and Training, Retail and eCommerce, Sports and Entertainment, Media and Publishing, Food and Beverage",
    },
  ],
});

const industries = ref([
  {
    link: "/services/industries/health-care-and-fitness",
    img: "/images/health-care-and-fitness.webp",
    title: "Health Care and Fitness",
    description:
      "Healthcare, like most other industries, has undergone a rapid transformation, thanks to advancements in technology. The usage of smartphone medical applications has increased worldwide, with more and more people relying on them for everything from medical treatments to general health and well-being.",
  },
  {
    link: "/services/industries/education-and-training",
    img: "/images/education-and-training.webp",
    title: "Education and Training",
    description:
      "E-Learning is a way to provide quick delivery of lessons. As compared to traditional classroom teaching method, this mode has relatively quick delivery cycles. This indicates that the time required to learn is reduced to 25%-60% of what is required in traditional learning.",
  },
  {
    link: "/services/industries/retail-and-ecommerce",
    img: "/images/retail-and-ecommerce.webp",
    title: "Retail & eCommerce",
    description:
      "An enterprise eCommerce platform needs to handle a myriad of tasks, from rendering product catalogs to managing orders to connecting with third-party systems. The complexity of these tasks is compounded when you factor in large order volumes, multiple currencies, and different languages.",
  },
  {
    link: "/services/industries/sports-and-entertainment",
    img: "/images/sports-and-entertainment.webp",
    title: "Sports and Entertainment",
    description:
      "Sports entertainment is a type of spectacle which presents an ostensibly competitive event using a high level of theatrical flourish and extravagant presentation, with the intent purpose of entertaining an audience rather than of sporting competition.",
  },
  {
    link: "/services/industries/media-and-publishing",
    img: "/images/media-and-publishing.webp",
    title: "Media and Publishing",
    description:
      "Media & Publishing is the only organization dedicated to the needs of print and digital publishers in nonprofit organizations. AM&P also serves association business operations executives, communication professionals, designers, editors, and content creators, and the media they create.",
  },
  {
    link: "/services/industries/food-and-beverage",
    img: "/images/food-and-beverage.webp",
    title: "Food and Beverage",
    description:
      "F&B Solutions is an innovative B2B foodservice provider within the UK casual dining market. We create, build and develop diverse food and drink solutions under our own unique brands, packaging them into comprehensive and ready-to-operate solutions specifically for hospitality establishments.",
  },
]);
</script>
<template>
  <section class="pb-16 px-4 z-10 relative">
    <div class="max-w-screen-xl mx-auto px-4 text-center md:pt-10 md:pb-10">
      <NuxtImg
        src="/images/icons/icon-case-study.webp"
        alt="industry"
        width="110"
        height="80"
        class="mx-auto"
        loading="lazy"
        format="webp"
      />
      <h1 class="font-bold">
        <WrGradientText> Industries </WrGradientText>
      </h1>
    </div>
    <div class="py-12">
      <div
        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-screen-xl mx-auto lg:px-4"
      >
        <NuxtLink
          :to="industry.link"
          v-for="(industry, index) in industries"
          :key="index"
          class="block rounded-xl overflow-hidden dark:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.5)] dark:hover:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.8)] hover:[box-shadow:0_.0625rem_.75rem_0_rgba(38,57,82,.2)] [box-shadow:0_.3em_.3em_-.3em_hsla(0,0%,4%,.1),_0_0_0_.1rem_hsla(0,0%,4%,.08)] transition-all duration-200 bg-white dark:bg-transparent"
        >
          <NuxtImg
            :src="industry.img"
            :alt="industry.title"
            class="w-full h-52 object-cover"
            loading="lazy"
            format="webp"
          />
          <div class="p-5">
            <h3 class="font-semibold mb-2 text-xl text-[var(--primary)]">
              {{ industry.title }}
            </h3>
            <p class="text-sm leading-relaxed tracking-[0.5px]">
              {{ industry.description }}
            </p>
          </div>
        </NuxtLink>
      </div>
    </div>

    <div class="pt-12">
      <div class="relative z-10 max-w-screen-xl mx-auto">
        <h2 class="text-center">
          <WrGradientText text="Trusted for excellence and efficiency" />
          <p class="lg:text-lg leading-[1.7] text-[var(--foreground)]">
            Webreinvent is trusted by leading organisations to enhance their
            development and operational efficiency.
          </p>
        </h2>
        <WrTestimonialCardCarousel class="mt-12" />
        <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7"
          >View All</WrButton
        >
      </div>
    </div>
  </section>
</template>
